import { render, staticRenderFns } from "./imageTxtInfoStyle.vue?vue&type=template&id=0a5a68f5&scoped=true"
import script from "./imageTxtInfoStyle.vue?vue&type=script&lang=js"
export * from "./imageTxtInfoStyle.vue?vue&type=script&lang=js"
import style0 from "./imageTxtInfoStyle.vue?vue&type=style&index=0&id=0a5a68f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a68f5",
  null
  
)

export default component.exports